import { Button } from "@joonapp/web-shared"
import { SessionBooking } from "@joonapp/web-shared"

import useUserRole from "../../../../hooks/useUserRole"
import useSession from "../hooks/useSession"

const LateCancelButton = ({ session }: { session: SessionBooking }) => {
  const { handleLateCancelSession, showLateCancelButton } = useSession(session)
  const { isClientOfOtherCoach } = useUserRole()

  if (!showLateCancelButton) return <></>

  return (
    <Button
      text="Late cancel"
      buttonType="redSecondary"
      onClick={handleLateCancelSession}
      fullWidth
      disabled={isClientOfOtherCoach}
    />
  )
}

export default LateCancelButton
